<template>
  <BaseDropdown class="base">
    <template v-slot:activator>
      <div class="title-wrapper">
        <span class="text">{{ title }}</span>
        <i class="fa fa-angle-down text-color"></i>
      </div>
    </template>
    <template v-slot:items>
      <slot></slot>
    </template>
  </BaseDropdown>
</template>

<script>
import BaseDropdown from "@/base/header/components/BaseDropdown";
export default {
  name: "Dropdown",
  components: {
    BaseDropdown,
  },
  props: {
    title: {
      type: String,
      required: true,
      default: "No title",
    },
  },
};
</script>

<style lang="scss" scoped>
.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  font-family: "Noto Serif SC", serif;
  color: $text-color;
}

.title-wrapper .fa {
  font-size: 18px;
}

.title-wrapper .text-color {
  color: $text-color;
  -webkit-text-stroke: 1.5px $white;
}

.base:hover .title-wrapper {
  color: $primary-dark !important;
  .text-color {
    -webkit-text-stroke: 1.5px $white;
    color: $primary-dark !important;
  }
}

.base:hover .fa {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.text {
  width: fit-content;
  font-weight: 400;
}

@media (max-width: 991.98px) {
  .text {
    font-size: 14px !important;
    color: $white !important;
  }

  .title-wrapper .text-color {
    color: $white;
    -webkit-text-stroke: 1.5px $primary-dark;
  }

  .base:hover .title-wrapper {
  color: $primary-color !important;
  .text-color {
    -webkit-text-stroke: 1.5px $primary-dark;
    color: $white !important;
  }
}
}
</style>
